import React from "react";

const InputField = () => {
  const addElementId = (event) => {
    event.dataTransfer.setData("text/plain", event.target.id);
  };
  return (
    <div className="input-container ">
      <h5>Drag and Drop Fields</h5>
      <label
        draggable="true"
        id="paragraph"
        onDragStart={addElementId}
        className=" input-icons bot-btn"
      >
        {/* <span className="material-symbols-outlined pe-1 fs-3  ">article</span>
        <span> article</span> */}

        <i class="fa-regular fa-file-lines"></i>
        <span> article</span>
      </label>
      <label
        draggable="true"
        id="image"
        onDragStart={addElementId}
        className=" input-icons bot-btn"
      >
        <i class="fa-regular fa-image"></i>
        <span> image</span>
      </label>
      <label
        draggable="true"
        id="image_and_paragraph"
        onDragStart={addElementId}
        className=" input-icons bot-btn"
      >
        <i class="fa-regular fa-image"></i>{" "}
        <i class="fa-regular fa-file-lines"></i>
        {/* <span className="material-symbols-outlined pe-1 fs-3  ">article</span> */}
        <span> Image-Text</span>
      </label>
      {/* <label draggable="true" id="paragraph_and_image" onDragStart={addElementId}>
                <span className="material-symbols-outlined">
                    article
                </span>
                <span className="material-symbols-outlined">
                    image
                </span>
            </label>
            <label draggable="true" id="image_and_image" onDragStart={addElementId}>
                <span className="material-symbols-outlined">
                    image
                </span>     
                <span className="material-symbols-outlined">
                    image
                </span>
            </label> */}
    </div>
  );
};

export default InputField;
